module.exports = __webpack_public_path__ + "img/illu4.1d5d0f90.png";